// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.variant-options {
  width: 100%;
  display: inline-block;
}

.selected-option {
  text-align: center !important;
  font-weight: bolder;
  display: inline-block;
  color: #747574;
}

.variants {
  color: #333333 !important;
}

.variants:hover {
  background-color: var(--mf-primary-color) !important;
  color: var(--mf-white) !important;
}

.is-swatch {
  border-radius: 100% !important;
  width: 35px;
  height: 35px;
  border: 2px solid #ffffff;
}

.is-swatch:hover,
.is-swatch:active,
.selected-variant-is-swatch {
  box-shadow: 0 0 0 3px #c7c7c7;
}

.is-button {
  width: 80px;
  border: none !important;
  height: 50px;
  border-radius: var(--bradius);
  color: #333333 !important;
  overflow: hidden;
  position: relative;
  -webkit-border-radius: var(--bradius);
  -moz-border-radius: var(--bradius);
  -ms-border-radius: var(--bradius);
  -o-border-radius: var(--bradius);
}

.is-button:hover,
.is-button:active,
.is-button:focus,
.selected-variant-is-button {
  box-shadow: 0 0 0 0px #ffffff !important;
  border: none !important;
  background-color: var(--mf-primary-color) !important;
  color: var(--mf-white) !important;
}

.circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: inline-block;
  margin-top: 5px;
  cursor: pointer;
  position: absolute;
  box-shadow: 0 0 0 3px #c7c7c7;
}

.swatch-diagonal-line {
  width: 6px;
  height: 28.5px;
  background-color: var(--mf-white);
  transform: rotate(45deg) translate(9px, -8px);
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 1px;
}

.swatch-diagonal-line::before {
  content: '';
  display: block;
  width: 3px;
  height: 32px;
  background-color: #c7c7c7;
  transform: translate(1.5px, -2px);
}

.button-diagonal-line {
  width: 2px;
  height: 94px;
  background-color: var(--mf-black);
  transform: rotate(59deg) translate(-30px, -60px);
  position: absolute;
}

.is-button.disabled {
  border: solid 1px var(--mf-black) !important;
}

/* Match Reactstrap's md column cutoff*/
@media (max-width: 767.98px) {
  .product-detail-page .config-option.configurable-select-option {
    display: block;
    width: 100% !important;
    margin-right: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Shop/ProductVariantSelect.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;;;;EAIE,wCAAwC;EACxC,uBAAuB;EACvB,oDAAoD;EACpD,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,cAAc;EACd,iCAAiC;EACjC,6CAA6C;EAC7C,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iCAAiC;EACjC,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,uCAAuC;AACvC;EACE;IACE,cAAc;IACd,sBAAsB;IACtB,eAAe;EACjB;AACF","sourcesContent":[".variant-options {\n  width: 100%;\n  display: inline-block;\n}\n\n.selected-option {\n  text-align: center !important;\n  font-weight: bolder;\n  display: inline-block;\n  color: #747574;\n}\n\n.variants {\n  color: #333333 !important;\n}\n\n.variants:hover {\n  background-color: var(--mf-primary-color) !important;\n  color: var(--mf-white) !important;\n}\n\n.is-swatch {\n  border-radius: 100% !important;\n  width: 35px;\n  height: 35px;\n  border: 2px solid #ffffff;\n}\n\n.is-swatch:hover,\n.is-swatch:active,\n.selected-variant-is-swatch {\n  box-shadow: 0 0 0 3px #c7c7c7;\n}\n\n.is-button {\n  width: 80px;\n  border: none !important;\n  height: 50px;\n  border-radius: var(--bradius);\n  color: #333333 !important;\n  overflow: hidden;\n  position: relative;\n  -webkit-border-radius: var(--bradius);\n  -moz-border-radius: var(--bradius);\n  -ms-border-radius: var(--bradius);\n  -o-border-radius: var(--bradius);\n}\n\n.is-button:hover,\n.is-button:active,\n.is-button:focus,\n.selected-variant-is-button {\n  box-shadow: 0 0 0 0px #ffffff !important;\n  border: none !important;\n  background-color: var(--mf-primary-color) !important;\n  color: var(--mf-white) !important;\n}\n\n.circle {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: inline-block;\n  margin-top: 5px;\n  cursor: pointer;\n  position: absolute;\n  box-shadow: 0 0 0 3px #c7c7c7;\n}\n\n.swatch-diagonal-line {\n  width: 6px;\n  height: 28.5px;\n  background-color: var(--mf-white);\n  transform: rotate(45deg) translate(9px, -8px);\n  border-bottom-right-radius: 2px;\n  border-bottom-left-radius: 1px;\n}\n\n.swatch-diagonal-line::before {\n  content: '';\n  display: block;\n  width: 3px;\n  height: 32px;\n  background-color: #c7c7c7;\n  transform: translate(1.5px, -2px);\n}\n\n.button-diagonal-line {\n  width: 2px;\n  height: 94px;\n  background-color: var(--mf-black);\n  transform: rotate(59deg) translate(-30px, -60px);\n  position: absolute;\n}\n\n.is-button.disabled {\n  border: solid 1px var(--mf-black) !important;\n}\n\n/* Match Reactstrap's md column cutoff*/\n@media (max-width: 767.98px) {\n  .product-detail-page .config-option.configurable-select-option {\n    display: block;\n    width: 100% !important;\n    margin-right: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
